module.exports = __webpack_public_path__ + "static/media/project-abstraack-open-mind2.0c5d91ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/project-abstraack-open-mind2.jpg
// module id = 334
// module chunks = 0